<div class="-confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="cancel-confirm-title">
  <h2 id="cancel-confirm-title" mat-dialog-title>
    <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
    {{ title }}?
  </h2>

  <mat-dialog-content>
    <p>
      {{ content }}
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      mat-button
      type="button"
      data-testid="cancel-action-button"
      (click)="cancel()"
      aria-label="Cancel"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      color="primary"
      data-testid="confirm-action-button"
      type="button"
      (click)="confirm()"
    >
      {{ confirmLabel }}
    </button>
  </mat-dialog-actions>
</div>
